import { FilterByPopover } from './FilterByPopover';
import { GroupByPopover } from './GroupByPopover';
import { SortByPopover } from './SortByPopover';
import { SettingsPopover } from './SettingsPopover';

export const Controls = () => (
    <div className="bg-gray-50 border-b border-gray-200 flex gap-2 items-baseline p-3 sticky top-0 z-(--z-sticky)">
        <GroupByPopover />
        <FilterByPopover />
        <SortByPopover />
        <SettingsPopover />
    </div>
);
